<script>
  import {onDestroy} from 'svelte';
  import {showAudioDownloadIndicator} from './Audio';
  import Dialog from '../../../../components/dialog/Dialog.svelte';

  let downloadStatus = '';
  let isOpen = false;

  const audioSubscription = showAudioDownloadIndicator.subscribe(value => {
    downloadStatus = value;
    isOpen = value !== '';
  });

  function closeDialog() {
    isOpen = false;
  }

  onDestroy(audioSubscription);
</script>

<Dialog bind:isDialogOpen={isOpen} useIfShow={true} noBackground={true} noTouch={true}>
  <div class="pointer-events-none relative flex h-full w-full items-center justify-center">
    <div class="pointer-events-none absolute left-0 top-0 flex h-full w-full items-end justify-end pb-32">
      {#if downloadStatus === 'downloading'}
        <div class="pointer-events-auto flex border border-amber-500" style="width: 320px; height: 128px;">
          <div class="flex h-full w-full bg-amber-200">
            <div class="px-3 pt-3">
              <i class="fa-solid fa-spinner rotating"></i>
            </div>
            <div class="flex h-full w-full flex-col gap-1">
              <div class="flex justify-between pr-2 pt-2">
                <h1 class="text-lg font-bold">Download in Progress</h1>
                <button on:click={closeDialog}>
                  <i class="fa-solid fa-xmark text-lg font-bold"></i>
                </button>
              </div>
              <p>Your audio file download is in progress. You may continue editing like normal.</p>
            </div>
          </div>
          <div class="h-full bg-amber-500">&nbsp;&nbsp;</div>
        </div>
      {:else if downloadStatus === 'complete'}
        <div class="pointer-events-auto flex border border-emerald-500" style="width: 320px; height: auto;">
          <div class="flex h-full w-full bg-emerald-200">
            <div class="px-3 py-3">
              <i class="fa-solid fa-circle-check"></i>
            </div>
            <div class="flex h-full w-full flex-col gap-1">
              <div class="flex justify-between pr-2 pt-2">
                <h1 class="text-lg font-bold">Download complete!</h1>
                <button on:click={closeDialog}>
                  <i class="fa-solid fa-xmark text-lg font-bold"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="h-full bg-emerald-500 py-3">&nbsp;&nbsp;</div>
        </div>
      {:else if downloadStatus === 'error'}
        <div class="pointer-events-auto flex border border-rose-500" style="width: 320px; height: 160px;">
          <div class="flex h-full w-full bg-rose-200">
            <div class="px-3 py-3">
              <i class="fa-solid fa-circle-check"></i>
            </div>
            <div class="flex h-full w-full flex-col gap-1">
              <div class="flex justify-between pr-2 pt-2">
                <h1 class="text-lg font-bold">Download failed!</h1>
                <button on:click={closeDialog}>
                  <i class="fa-solid fa-xmark text-lg font-bold"></i>
                </button>
              </div>
              <p>Failed to download audio. Please try again later.</p>
            </div>
          </div>
          <div class="h-full bg-rose-500">&nbsp;&nbsp;</div>
        </div>
      {/if}
    </div>
  </div>
</Dialog>
